import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { IMessageShortListItem, MessageShortListItem } from "./messageShortListItem";

export interface IMessageShortListItems extends IListItems<IMessageShortListItem> {}

export class MessageShortListItems extends ListItems<MessageShortListItem> implements IMessageShortListItems {
    constructor();
    constructor(obj: IMessageShortListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, MessageShortListItem);
    }
}